var _style, _polygon, _polygon2, _rect, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYesIconsIconTrusted(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 108 100.2",
    style: {
      enableBackground: "new 0 0 108 100.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#fff;}\n\t.st1{fill:none;stroke:#fff;stroke-width:0.6081;stroke-miterlimit:10;}\n\t.st2{fill:none;}\n")), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "68.9,42.3 67,40.3 50.8,56.5 45.2,50.9 43.2,52.9 50.8,60.5 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "68.9,42.3 67,40.3 50.8,56.5 45.2,50.9 43.2,52.9 50.8,60.5 "
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20.6,
    y: 10.5,
    className: "st2",
    width: 66.7,
    height: 79.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.8,19l29.8-5.4L84.3,19v37.5c0,16.8-16.5,30.2-30.3,30.2S23.8,73.3,23.8,56.6V19z M20.9,56.6 c0,18.6,17.8,33.1,33.1,33.1s33.1-14.5,33.1-33.1V16.7l-33.5-5.9l-32.6,5.9L20.9,56.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M23.8,19l29.8-5.4L84.3,19v37.5c0,16.8-16.5,30.2-30.3,30.2S23.8,73.3,23.8,56.6V19z M20.9,56.6 c0,18.6,17.8,33.1,33.1,33.1s33.1-14.5,33.1-33.1V16.7l-33.5-5.9l-32.6,5.9L20.9,56.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M35,28.5l18.6-3.4L73,28.5v28.1c0,9.9-10.7,19-19,19s-19-9.2-19-19V28.5z M54,78.4c9.6,0,21.8-10.3,21.8-21.8 V26.1l-22.2-3.9l-21.4,3.9v30.5C32.2,68.1,44.4,78.4,54,78.4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M35,28.5l18.6-3.4L73,28.5v28.1c0,9.9-10.7,19-19,19s-19-9.2-19-19V28.5z M54,78.4c9.6,0,21.8-10.3,21.8-21.8 V26.1l-22.2-3.9l-21.4,3.9v30.5C32.2,68.1,44.4,78.4,54,78.4z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYesIconsIconTrusted);
export default __webpack_public_path__ + "static/media/YES-ICONS_ICON-TRUSTED.a4d854c61bf32dbe55d1c88e9d08ef92.svg";
export { ForwardRef as ReactComponent };